import { Link, Typography } from '@mui/material';
import React from 'react';

interface LocationTypes {
  name: string;
  href: string;
  target?: string;
}

const getFontSize = (name: string) => {
  if (name.length > 40) return '0.85rem';
  if (name.length > 28) return '1rem';
  return '1.2rem';
};

export const Location: React.FC<LocationTypes> = ({ name, href, target }) => {
  const fontSize = getFontSize(name);
  const style = {
    color: '#0A3551',
    fontSize,
    fontWeight: '700',
    textTransform: 'uppercase',
    textAlign: 'right',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    lineHeight: 1.2,
    '@media (orientation: portrait)': {
      fontSize,
    },
  };

  return (
    <Typography sx={{ ...style }}>({name})</Typography>
    // <Link sx={style} href={href} target={target} underline="none">
    //   ({name})
    // </Link>
  );
};
